import * as angular from "angular";
import {IController} from "angular";
import {RuleFilterEntityType} from "../../types/rule-filter-entity.type";
import {RuleFilterOperatorsType} from "../../types/rule-filter-operators.type";
import {RuleFilterDataType} from "../../types/rule-filter-data.type";
import {ConditionModel} from "../../models/condition.model";
import {RuleFilterModel} from "../../models/rule-filter.model";

export class RuleConditionComponent implements IController {

  condition: ConditionModel;
  filterOptions: RuleFilterModel[];
  metaData: any[];
  onChangeFilter: Function;

  public optionFiltersMap: any = {};
  public ruleFilterEntityType: typeof RuleFilterEntityType = RuleFilterEntityType;
  public multipleValuesOperators: string[] = [RuleFilterOperatorsType.in, RuleFilterOperatorsType.nin];
  public ruleFilterDataType: typeof RuleFilterDataType = RuleFilterDataType;
  public conditionId: string;

  constructor(private UUIDService) {
  }

  $onInit() {
    this.conditionId = this.UUIDService.generate();
    if (this.filterOptions) {
      this._initOptionFiltersMap();
      this.transformStringValuesToFloat();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.filterOptions && !changes.filterOptions.isFirstChange()) {
      this._initOptionFiltersMap();
      this.transformStringValuesToFloat();
    }

    if (changes.condition && !changes.condition.isFirstChange()) {
      this.transformStringValuesToFloat();
    }
  }


  onChipsChange(items: string[]) {
    this.condition.value = items;
    this.onChangeFilter({condition: this.condition});
  }

  onTimeChange(time: string) {
    this.condition.value = time;
    this.onChangeFilter({condition: this.condition});
  }


  onDateChange(date: number) {
    this.condition.value = date;
    this.onChangeFilter({condition: this.condition});
  }

  isMultipleValueOperator(operator) {
    return this.multipleValuesOperators.includes(operator);
  }

  onSelectValueChange(value: any) {
    this.condition.value = value;
    this.onChangeFilter({condition: this.condition});
  }

  onMultiSelectValueChange(values: any[]) {
    this.condition.value = values;
    this.onChangeFilter({condition: this.condition});
  }

  onChangeOperator(): void {
    if (this.condition?.value?.key) {
      this.condition.value.value = undefined;
    } else {
      this.condition.value = undefined;
    }
    this.onChangeFilter({condition: this.condition});
  }

  onChangeFilterType(): void {
    this.condition.value = undefined;
    this.condition.type = this.optionFiltersMap[this.condition.fieldName].type;
    if (this.optionFiltersMap[this.condition.fieldName].type === this.ruleFilterDataType.Dimensions) {
      this.condition.value = {
        width: undefined,
        height: undefined,
        length: undefined
      }
    }
    this.onChangeFilter({condition: this.condition});
  }

  private _initOptionFiltersMap() {
    this.filterOptions.forEach(o => {
      this.optionFiltersMap[o.fieldName] = o;
    })
  }

  private transformStringValuesToFloat() {
    if (this.condition.fieldName && this.optionFiltersMap[this.condition.fieldName].type === this.ruleFilterDataType.Number && !!this.condition.value) {
      this.condition.value = this.toFloat(this.condition.value);
    }

    if (this.condition.fieldName && this.optionFiltersMap[this.condition.fieldName].type === this.ruleFilterDataType.Dimensions && !!this.condition.value) {
      this.condition.value.width = this.toFloat(this.condition.value.width);
      this.condition.value.length = this.toFloat(this.condition.value.length);
      this.condition.value.height = this.toFloat(this.condition.value.height);
    }
  }

  private toFloat(value: string): number {
    return parseFloat(value);
  }

}


angular
  .module('bringoz.admin.ruleEngine')
  .component('ruleCondition', {
    bindings: {
      condition: '<',
      filterOptions: '<',
      metaData: '<?',
      onChangeFilter: '&'
    },
    template: require('./rule-condition.html').default,
    controller: RuleConditionComponent
  });

